import selectInsurance from 'utils/selectInsurance';
import getPatientPhone3 from 'utils/print/getPatientPhone3';

const getInsuranceInsuredsPhone3 = ({ patient, insurance, value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  const selectedInsuranceRelationToInsured = selectedInsurance
    ? selectedInsurance['Relation to Insured']
    : 'none';
  if (selectedInsuranceRelationToInsured === 'Self') {
    return getPatientPhone3({
      ...otherProps,
      patient,
      insurance,
    });
  }

  return null;
};

export default getInsuranceInsuredsPhone3;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceInsuredsPhone3.js